import DefaultCL from "../../../../src/gatsby-theme-carbon/templates/DefaultCL";
import { TkFooter } from "../../../../src/components/toolkit/TkFooter";
import ChecklistRequirements from "../../../../src/components/requirements/checklistRequirements.js";
import * as React from 'react';
export default {
  DefaultCL,
  TkFooter,
  ChecklistRequirements,
  React
};